import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import router from './router'
import axios from "axios"
import VueAxios from 'vue-axios'
//全局样式
import global from './assets/css/global.css'

const app = createApp(App)
app.use(VueAxios,axios)
app.use(ElementPlus)
app.use(router)
app.use(global)
app.mount('#app')

